import { render, staticRenderFns } from "./NewLogoWaybillEntry.vue?vue&type=template&id=44c5772c&scoped=true&"
import script from "./NewLogoWaybillEntry.vue?vue&type=script&lang=js&"
export * from "./NewLogoWaybillEntry.vue?vue&type=script&lang=js&"
import style0 from "./NewLogoWaybillEntry.vue?vue&type=style&index=0&id=44c5772c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c5772c",
  null
  
)

export default component.exports